import React from "react";
import { Control } from "react-hook-form";
import { FormInputNumber } from "../../../../components/ui/Input/FormInputNumber/FormInputNumber";

interface ProcessTableProps {
  processList: any[];
  control: Control<any>;
  validateTotalValue: (id: string, value: string) => boolean;
  disabled?: boolean;
}

/**
 * Separate component for rendering process table
 * Follows Single Responsibility Principle - only renders process table
 */
export const RecipeProcessTable: React.FC<ProcessTableProps> = ({
  processList,
  control,
  validateTotalValue,
  disabled = false
}) => {
  if (!processList || processList.length === 0) {
    return null;
  }

  return (
    <div className="tw-space-y-3">
      <h3 className="tw-text-sm tw-font-semibold tw-text-gray-700 tw-uppercase tw-tracking-wide">Process (s)</h3>
      <div className="tw-overflow-x-auto tw-rounded-lg tw-border tw-border-gray-200">
        <table className="tw-min-w-full tw-divide-y tw-divide-gray-200">
          <thead className="tw-bg-gray-50">
            <tr>
              <th className="tw-px-3.5 tw-py-3.5 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider tw-w-3/4">
                Name
              </th>
              <th className="tw-px-3.5 tw-py-3.5 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider tw-w-1/4">
                Value %
              </th>
            </tr>
          </thead>
          <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
            {processList.map((process: any) => {
              const processId = process.data?.reference?.processId;
              return (
                <tr className="tw-border-b hover:tw-bg-gray-50" key={processId}>
                  <td className="tw-px-3.5 tw-py-3.5">
                    <p className="tw-text-sm tw-text-gray-700">{process?.data?.label}</p>
                  </td>
                  <td className="tw-px-3.5 tw-py-3.5">
                    <FormInputNumber
                      control={control}
                      name={`process-${processId}.value` as any}
                      label=""
                      placeholder="Enter value %"
                      rules={{
                        validate: {
                          valueCheck: (value: any) => validateTotalValue(processId, value)
                        }
                      }}
                      enableMinus={false}
                      disabled={disabled}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
